import React from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "../content/nav";

const MESSAGE =
  "Hello Shreem Mantra Energy — I have a question about a stone and its laboratory report.";

/**
 * Secondary contact path only. Add to Cart and the booking flow stay primary.
 * Until a real WhatsApp number is configured the button routes to /contact
 * rather than to a broken wa.me link.
 */
export function WhatsAppFab() {
  const navigate = useNavigate();
  const digits = (COMPANY.whatsapp || "").replace(/\D/g, "");
  const configured = digits.length >= 8;

  if (configured) {
    return (
      <a
        href={`https://wa.me/${digits}?text=${encodeURIComponent(MESSAGE)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="wa-fab"
        aria-label="Message us on WhatsApp"
        data-testid="whatsapp-fab"
      >
        <MessageCircle className="h-6 w-6" aria-hidden="true" />
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={() => navigate("/contact")}
      className="wa-fab"
      aria-label="Message us"
      title="Message us"
      data-testid="whatsapp-fab"
    >
      <MessageCircle className="h-6 w-6" aria-hidden="true" />
    </button>
  );
}
